import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getWorkspacesFromExportRequests } from 'services/results'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { GetWorkspacesFromExportRequestsResponse } from 'services/results/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetWorkspacesFromExportRequests = (
  options?: Omit<UseQueryOptions<GetWorkspacesFromExportRequestsResponse, ApiErrorResponse>, 'queryKey'>
) => {
  return useQuery<GetWorkspacesFromExportRequestsResponse, ApiErrorResponse>({
    queryKey: ResultsQueryKeys.WorkspacesFromExportRequests(),
    queryFn: ({ signal }) => getWorkspacesFromExportRequests({ signal }),
    ...options
  })
}
